var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ItpBadge", {
    attrs: {
      variant: "fixed-asset-type--" + _vm.value,
      text: _vm.types[_vm.value],
      "no-box-shadow": ""
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }